import type { IconDefinition } from "@fortawesome/fontawesome-svg-core";

import Icon from "@Components/generic/icon";
import KeyboardKeys from "@Enums/KeyboardKeys";
import { useTheme } from "@mui/material";

import { DrawerActionButtonBox } from "@Components/training-plans/training-plans-drawer/training-plans-drawer.styled";

interface ITrainingPlansDrawerActionButton {
  icon: IconDefinition;
  ariaLabel: string;
  onClick: () => void;
}

const TrainingPlansDrawerActionButton = ({ icon, ariaLabel, onClick }: ITrainingPlansDrawerActionButton) => {
  const theme = useTheme();

  return (
    <DrawerActionButtonBox
      aria-label={ariaLabel}
      onClick={onClick}
      onKeyDown={event => {
        if (event.key === KeyboardKeys.ENTER || event.key === KeyboardKeys.SPACE) {
          event.preventDefault();
          onClick();
        }
      }}
      role="button"
      tabIndex={0}
    >
      <Icon icon={icon} color={theme.palette.dsBase.v200} />
    </DrawerActionButtonBox>
  );
};

export default TrainingPlansDrawerActionButton;
